import type { Product } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getProducts = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Product[]>({
      method: 'GET',
      url: '/api/app/products/products',
    },
    { apiName: this.apiName,...config });
}